import { toast } from "react-toastify";
import { BASE_URL } from "./connectionUrl";

export const getMedicineSalt = async (
  token,
  type = null,
  page = null,
  pageSize = null,
  q = null
) => {
  const endpoint =
    type === null
      ? `/api/v1/admin/medicine_salts?page=${page}&per_page=${pageSize}${
          q ? `&q=${q}` : ""
        }`
      : `/api/v1/admin/medicine_salts?type=${type}`;
  try {
    const response = await fetch(
      // eslint-disable-next-line no-undef
      `${BASE_URL}${endpoint}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      }
    );

    const data = await response.json();
    if (data.status.status === "SUCCESS") {
      return data;
    } else {
      toast.error(data?.status?.message || "something went wrong");
    }
  } catch (error) {
    toast.error(error.message || "something went wrong");
  }
};
